import { render, staticRenderFns } from "./AdministrativeVisit.vue?vue&type=template&id=5f6949be"
import script from "./AdministrativeVisit.vue?vue&type=script&lang=js"
export * from "./AdministrativeVisit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports